import BaseRequest from './BaseRequest';
import HTTPRequest from '../HTTPRequest';

export default class Memberships extends BaseRequest {
    /**
     * Memberships constructor
     * 
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(requestMode = 'customer', providerId = '', customerId = '', auth = true, fowardRequest = false) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('Memberships');
        this.setEndpoint('memberships');
    }

    /**
     * @param {string} membershipId
     * @param {string} customerId
     * @param {string} paymentPlanId
     * @param {string} eventId
     * @param {string} appointmentSlot
     * @param {string} returnTo
     * @return {object}
     */
    async initiatePurchase(membershipId = '', customerId = '', paymentPlanId = '', eventId = '', appointmentSlot = '', returnTo = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }
        const returnToUrl = this.buildReturnUrl(returnTo, {
            'customer_id': customerId,
            'membership_id': membershipId,
            'payment_plan_id': paymentPlanId,
            'event_id': eventId,
            'provider_id': this.getProviderId(),
            'appointment_slot': appointmentSlot
        });

        let body = {
            'customer': customerId,
            'return_to': returnToUrl
        };
        if (appointmentSlot != '') {
            body['appointment_slot'] = appointmentSlot;
        }
        if (eventId != '') {
            body['event'] = eventId;
        }
        if (paymentPlanId != '') {
            body['payment_plan'] = paymentPlanId;
        }

        const request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${membershipId}/initiate_purchase`,
            this.getHeaders(),
            {},
            body
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(
                this.getClassName(),
                'initiatePurchase',
                {
                    'membershipId': membershipId,
                    'customerId': customerId,
                    'paymentPlanId': paymentPlanId,
                    'eventId': eventId,
                    'appointmentSlot': appointmentSlot,
                    'returnTo': returnTo
                }
            );
        }

        return await request.sendRequest();
    }
}